"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.explorerColumnPresetUsersDefault = void 0;
var ExplorerColumnPresetType_1 = require("Modules/explorers/types/ExplorerColumnPresetType");
var parseColumnNamesToColumnPresetData_1 = require("Modules/explorers/utils/parseColumnNamesToColumnPresetData");
var columns = [
    "displayName",
    "customIdLabel",
    "toProfile",
    "role",
    "location",
    "joinDate",
    "lastLogin",
    "totalPoints",
    "socialExplorer.traqsJoined",
    "socialExplorer.traqsDone",
    "socialExplorer.modulesJoined",
    "socialExplorer.modulesDone",
    "socialExplorer.stepsToDo",
    "socialExplorer.stepsDone",
    "socialExplorer.groupsJoined",
    "socialExplorer.groupTitles",
];
exports.explorerColumnPresetUsersDefault = (0, parseColumnNamesToColumnPresetData_1.parseColumnNamesToColumnPresetData)(columns, ExplorerColumnPresetType_1.ExplorerColumnPresetType.users);
